// scripts/components/scrollToTop.js
export function initStt(container = document) {
  container.querySelectorAll('.scroll-to-top').forEach(btn => {
    const threshold = parseInt(btn.dataset.scrollThreshold) || 300;
    const offsetX = parseInt(btn.dataset.offsetX) || 20; // décalage depuis la droite
    const offsetY = parseInt(btn.dataset.offsetY) || 20; // décalage depuis le bas

    // Placement fixe avec offsets dynamiques
    btn.style.position = 'fixed';
    btn.style.bottom = `${offsetY}px`;
    btn.style.right = `${offsetX}px`;

    const toggleVisibility = () => {
      if (window.scrollY > threshold) btn.classList.add('active');
      else btn.classList.remove('active');
    };

    window.addEventListener('scroll', toggleVisibility);
    toggleVisibility(); // initial check

    btn.addEventListener('click', e => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}